export const clusterCircle = {
  id: 'clusters',
  type: 'circle',
  paint: {
    'circle-color': '#fff',
    'circle-radius': 12,
    'circle-stroke-width': 2,
    'circle-stroke-color': '#0061D9',
  },
}
export const clusterCount = {
  id: 'cluster-count',
  type: 'symbol',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': ['get', 'point_count_abbreviated'],
    'text-size': 18,
  },
}
